import React from "react";

function Barcode({ size, color }) {
  return (
    <div
      style={{
        width: size,
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 400 266.67"
        fill={color}
      >
        <g>
          <rect
            width="26.76"
            height="266.67"
            x="287.48"
            rx="12.52"
            ry="12.52"
          ></rect>
          <rect
            width="54.54"
            height="266.67"
            x="57.98"
            rx="12.52"
            ry="12.52"
          ></rect>
          <rect
            width="54.54"
            height="266.67"
            x="201.72"
            rx="12.52"
            ry="12.52"
          ></rect>
          <rect
            width="54.54"
            height="266.67"
            x="345.46"
            rx="12.52"
            ry="12.52"
          ></rect>
          <rect
            width="26.76"
            height="266.67"
            x="143.74"
            rx="12.52"
            ry="12.52"
          ></rect>
          <rect width="26.76" height="266.67" rx="12.52" ry="12.52"></rect>
        </g>
      </svg>
    </div>
  );
}

export default Barcode;
